import { ThemeProvider } from '@mui/material';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import AuthRoute from './_components/auth/auth-route';
import { theme } from './_styles/theme.styles';
import './App.css';

// import { LogIndex } from './pages/log/log-index';
import { LoginForgotPassword } from './pages/login/login-forgotPassword';
import { LoginIndex } from './pages/login/login-index';
import { LoginResetPassword } from './pages/login/login-resetPassword';
import { LoginVerifyCode } from './pages/login/login-verifyCode';

import { AuctionIndex } from './pages/auction/auction-index';
import { AppScreen } from './screens/app-screen';
import { AuthScreen } from './screens/auth-screen';



function App() {
    return (
        <ThemeProvider theme={theme}>
            <BrowserRouter>
                <Routes>

                    <Route path="/login" element={<AuthScreen />}>
                        <Route path="" element={<LoginIndex />} />
                        <Route path="verifycode/:email" element={<LoginVerifyCode />} />

                        {/*Test*/}
                        {/*<Route path="verifyCode" element={<LoginVerifyCode />} />*/}
                        {/*<Route path="resetpassword" element={<LoginResetPassword />} />*/}
                        {/*end Test*/}


                        <Route path="forgotpassword" element={<LoginForgotPassword />} />
                        <Route path="resetpassword/:code" element={<LoginResetPassword />} />
                    </Route>

                    <Route path="/" element={<AuthRoute element={<AppScreen />} />}>
                        <Route path="/" element={<AuctionIndex />} />
                    </Route>
                </Routes>
            </BrowserRouter>
        </ThemeProvider >
    );
}

export default App;
